// extracted by mini-css-extract-plugin
module.exports =  {"button":"M8QVCtn","trigger":"QZq5XRX","open":"LcGgrCJ","outlined":"dBr3vu5","disabled":"QowhdLx"};